import React from "react";
import { PageWrapper } from "components/pages";
import { TravelList } from "features/TravelList";

const TravelPage = () => {
  return (
    <PageWrapper>
      <TravelList />
    </PageWrapper>
  );
};

export default TravelPage;
